import { render, staticRenderFns } from "./CharteredCar.vue?vue&type=template&id=2907fad8&scoped=true"
import script from "./CharteredCar.vue?vue&type=script&lang=js"
export * from "./CharteredCar.vue?vue&type=script&lang=js"
import style0 from "./CharteredCar.vue?vue&type=style&index=0&id=2907fad8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2907fad8",
  null
  
)

export default component.exports